<template>
  <section class="pt-9 px-11">
    <section class="pdf-item flex items-start">
      <div class="mr-8 w-48 flex-shrink-0">
        <!-- image -->
        <img
          :src="bookData.imageURl"
          alt="Cover image of this book"
          class="shadow-md h-auto flex-shrink-0 mb-4"
        />
        <!-- details -->
        <ul class="space-y-2 mb-3">
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">ISBN:</h4>
            <!-- {{ bookData.isbn }} -->
            9789811809002
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Publisher:</h4>
            World Scientific Publishing
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Pub. Date:</h4>
            <!-- {{ bookData.pubDate }} -->
            June 22, 2020
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Format:</h4>
            Hardcover, Softcover
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Edition:</h4>
            Edition name
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Price:</h4>
            SGD 12.00
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Page count:</h4>
            56
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Category:</h4>
            Comics &amp; Graphic Novels
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Imprint:</h4>
            <!-- {{ bookData.imprint }} -->
            Amicus Inc
          </li>
          <li class="text-black-600 text-10px">
            <h4 class="text-grey-700 inline-block">Target Audience:</h4>
            Name Target Audience, One more name target audience
          </li>
        </ul>
        <!-- price -->
        <div
          class="
            bg-grey-400
            rounded
            px-10
            py-12
            flex flex-col
            items-center
            self-center
            flex-shrink-0
          "
        >
          <span
            class="
              before:empty-content
              before:w-1
              before:h-1
              before:rounded-full
              before:mr-1
              text-10px
              flex
              items-center
              before:bg-green-700
              text-green-700
              mb-1
            "
          >
            <!-- before:bg-red-600 text-red-600 -->
            Available
          </span>
          <span class="text-black-900 text-xl font-medium uppercase mb-4">
            SGD 12.00
          </span>
        </div>
      </div>

      <div>
        <!-- info -->
        <div class="mb-4">
          <h2 class="text-black-900 text-base mb-2 font-medium">
            {{ bookData.name }}
          </h2>
          <h3 class="text-grey-700 uppercase text-xxs font-medium">
            {{ bookData.author }}
          </h3>
        </div>

        <!-- description -->
        <div class="mb-5">
          <h5 class="text-grey-700 font-medium text-xxs mb-2 uppercase">
            Description
          </h5>
          <div class="text-black-600 text-10px space-y-2">
            <p>
              Throughout the history of mankind, the rise of societies, whether
              civilizations, nations, or communities, has been a story of human
              achievement. From the rise of the Akkadian empire in ancient
              Mesopotamia to the re-emergence of modern China, people constitute
              the basic denominator upon which societies build their success.
              The way people around the world think and behave is guided by a
              complex system of values. These values constitute key factors in
              the way economies are structured and their potential for further
              growth. To a large extent, they explain why Japan has gone through
              multiple lost decades; why Nordic countries accept the highest tax
              rates in the world, making their societies much more equal; why
              China has such a large trade surplus with the United States; or
              why some nations become stuck in a middle-income trap. It is these
              values, coupled with the right policies, that ultimately determine
              the destiny of nations.
            </p>
            <p>
              In this book, we explore how the combination of human values and
              policies affects national economic outcomes. We focus on certain
              key values conducive to growth: are people of a given nation, on
              average, hardworking, thrifty? Do they trust each other? Are they
              risk-takers? The harder people work, the higher the growth
              potential. Different savings patterns determine, to a large
              extent, whether a country will grow through investments and
              exports or consumption, and have generated large global imbalances
              over time. Trust goes a long way in explaining wealth and income
              inequalities and the role that governments can play in minimizing
              those inequalities. Economies with highly risk-averse citizens
              will stall. We also identify policies which have the greatest
              impact on economies. Political stability, much more so than any
              form of governance, is a precondition for growth. Free markets
              imply a process of creative destruction, free and fair
              competition, and a level playing field among companies. An
              educated workforce is a vital enabler of higher productivity and
              innovation. Corruption can seriously derail growth once it becomes
              endemic. Sound fiscal and monetary policies stabilize an economy
              as it goes through cycles and can greatly contribute to a more
              equal society and a more robust financial sector.
            </p>
          </div>
        </div>
        <!-- endorsement -->
        <div class="mb-5">
          <h5 class="text-grey-700 font-medium text-xxs mb-2 uppercase">
            Endorsement
          </h5>
          <div class="text-black-600 text-10px space-y-2">
            <p>
              Storm Dunlop is an author and translator, working mainly on
              material in the physical sciences and technology. Wil Tirion has
              been an uranographer (star-map maker) since 1977. His first star
              maps were published by the British Astronomical Association, and
              he has since contributed maps to numerous books and atlases. He is
              a recipient of the Dr. J. van der Bilt Prize awarded to weather
              and astronomy amateurs and in 1993 the International Astronomical
              Union named an asteroid after him.
            </p>
          </div>
        </div>
        <!-- promotional headline -->
        <div class="mb-5">
          <h5 class="text-grey-700 font-medium text-xxs mb-2 uppercase">
            Promotional headline
          </h5>
          <div class="text-black-600 text-10px space-y-2">
            <p>
              Storm Dunlop is an author and translator, working mainly on
              material in the physical sciences and technology. Wil Tirion has
              been an uranographer (star-map maker) since 1977. His first star
              maps were published by the British Astronomical Association, and
              he has since contributed maps to numerous books and atlases. He is
              a recipient of the Dr. J. van der Bilt Prize awarded to weather
              and astronomy amateurs and in 1993 the International Astronomical
              Union named an asteroid after him.
            </p>
          </div>
        </div>
        <!-- Official Recommendation -->
        <div class="mb-5">
          <h5 class="text-grey-700 font-medium text-xxs mb-2 uppercase">
            Official Recommendation
          </h5>
          <div class="text-black-600 text-10px space-y-2">
            <p>
              This book provides a good introduction for new astronomers,
              helping them enjoy the thrill of seeing one-time sky events,
              follow the changes in the night sky, and learn about the Milky Way
              and its resident stars.
            </p>
          </div>
        </div>
        <!-- Awards -->
        <div class="mb-5">
          <h5 class="text-grey-700 font-medium text-xxs mb-2 uppercase">
            Awards
          </h5>
          <div class="text-black-600 text-10px">
            <p>Book of the Year (2020)</p>
            <p>Best Literary Work (2019)</p>
          </div>
        </div>
        <!-- Publisher contacts -->
        <div class="mb-5">
          <h5 class="text-grey-700 font-medium text-xxs mb-2 uppercase">
            Distributor/publisher contacts
          </h5>
          <div class="mb-4">
            <h6 class="text-black-900 font-medium text-10px mb-1">
              Mailing Address
            </h6>
            <div class="text-black-600 text-10px">
              <p>Epigram Books</p>
              <p>1008 Toa Payoh North</p>
              <p>#03-08</p>
              <p>Singapore 318996</p>
              <p>
                Our showroom is a 5-minute walk from Braddell (NS18) MRT
                Station.
              </p>
            </div>
          </div>
          <div class="mb-4">
            <h6 class="text-black-900 font-medium text-10px mb-1">Telephone</h6>
            <div class="text-black-600 text-10px">
              <a href="tel:+6562924454">(+65) 6292 4456</a>
            </div>
          </div>
          <div class="mb-4">
            <h6 class="text-black-900 font-medium text-10px mb-1">E-mail</h6>
            <div class="text-black-600 text-10px underline">
              <a href="mailto:hello@epigram.sg">hello@epigram.sg</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  props: {
    bookData: {
      type: Object,
      required: true,
    },
  },
};
</script>
